module.exports = __webpack_public_path__ + "static/media/emptySectionNew.242fffd5.svg";